import React, {useState} from "react";
import {useViewerStore} from "../../../../../store/store";
import {Button, Flex} from "antd";
import completedIcon from "../../../../../assets/img/icons/completed-icon.png";
import errorIcon from "../../../../../assets/img/icons/error-icon.png";
import {generateMeasureLayout} from "../../Drawer/Drawer-Sections/5-Reports-Section/Reports/Measure_Layout.tsx";

const MeasureLayoutPopup = () => {


    const sceneViewer = useViewerStore(state => state.sceneViewer);


    const viewerSate = useViewerStore.getState();
    const [pdfGenerationStatus, setPdfGenerationStatus] = useState("default");

    const confirmGenerateReport = async () => {
        setPdfGenerationStatus('generating');
        const pdf = await generateMeasureLayout(sceneViewer, viewerSate);
        if (pdf) {
            const sfidString = sessionStorage.getItem('SalesForceId');
            pdf.save(`oneDRAW_Measure_Layout_${sfidString}.pdf`); // Set the file name and trigger download
            setPdfGenerationStatus('success');
        } else {
            setPdfGenerationStatus('error');
        }
    }

    const cancel = () => {
        //Close Alert
        sceneViewer.viewerAlert({show: false});
    };

    return (
        <>
            {

                pdfGenerationStatus === 'success' ? <Flex vertical justify={'center'} align={'center'}>
                    <p className="report-text">Measure Layout PDF Generated Successfully</p>
                    <img
                        src={completedIcon}
                        alt={"Completed Icon"}
                        width={50}
                        height={50}
                    />                       
                </Flex> : pdfGenerationStatus === 'error' ? <Flex vertical justify={'center'} align={'center'} gap={5}>
                    <p>Measure Layout PDF Generation Failed</p>
                    <img
                        src={errorIcon}
                        alt={"Error Icon"}
                        width={50}
                        height={50}
                    />
                </Flex> : pdfGenerationStatus === 'generating' ? <Flex justify={'center'} align={'center'} gap={10}>
                        <span className="loader-icon-spinner"></span>
                        <p className="report-text">Generating Measure Layout PDF</p>

                    </Flex> :

                    <>
                        <p className="report-text">Click Confirm to Generate and Download Measure Layout PDF</p>
                        <div className={"modal-bottom-action-button-container"}>
                            <Button
                                id={"confirmMeasureLayoutBtn"}
                                type="primary"
                                size="large"
                                className="editor__control--finalize modal-confirm-button"
                                onClick={confirmGenerateReport}
                            >
                                Confirm
                            </Button>

                            <Button
                                type="primary"
                                size="large"
                                className="editor__control--finalize modal-cancel-button"
                                onClick={cancel}
                            >
                                Cancel
                            </Button>
                        </div>
                    </>


            }
        </>
    )
}

export default MeasureLayoutPopup;